<template>
  <div id="divAnnouncement">
    <table align="center">
      <tr>
        <td valign="middle" align="center">
          <h2 style="color: red">--- ประกาศ ---</h2>
        </td>
      </tr>
      <tr>
        <td valign="middle" align="center">
          <h3 style="color: red">ปิดระบบ หมดเวลาทำการสอบ</h3>
          <br />
          <!-- <h5>
            ระบบจะเปิดให้ลงทะเบียนรอบเก็บตกใน<br>
            <b>14 ก.ค. 64 ณ เวลา 06.00น. - 22.00น.</b>
          </h5>
          <br /> <br />
                   <h5>
            และจะเปิดให้ทำการสอบรอบสุดท้ายในวันที่
            <b>15 ก.ค. 64</b>
          </h5> -->
          <h5> <br />
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSeOkXRSzkFeY6MJm4iPF0bFlRxZWY0HPbRmd1FXH5PFylprHw/viewform"
              >ขอความร่วมมือร่วมทำ google form
              เกี่ยวกับความคิดเห็นของท่านที่มีต่อการทำข้อสอบ NEPT
              เพื่อเป็นประโยชน์กับการพัฒนาต่อยอดในอนาคต</a
            >
          </h5>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    l_clear() {
      localStorage.removeItem("lastExam");
      localStorage.removeItem("timer_now");
      this.$store.dispatch("resetState");
    },
  },
  beforeMount() {
    this.l_clear();
  },
};
</script>

<style scoped>
#divAnnouncement {
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>